require('../scss/pages.scss');

import initFilters from './../../search/js/_filters-collection';

document.addEventListener('DOMContentLoaded', () =>  {
    initFilters();
});

